import { ModalConfirmationProps } from '../../../components/modals/ModalYesNo'

export const MIDDLE_SCREEN = 768
export const INITIAL_DRAFT_MODAL_CONFIRMATION: ModalConfirmationProps =
	{
		open: false,
		text: '',
		canBeSaved: false,
		isSave: false,
		isOkButton: undefined,
		loadingText: undefined,
	}
